import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '@material-ui/core';

import ROUTES from '../../../utils/consts';

import './not-found.css';

import Logo from '../../common/logo/logo';

const NotFound = () => {
  return (
    <section className="screen-container">
      <div className="screen-content">
        <div id="main-content" className="full-height">
          <div className="content-panel">
            <Logo />
            <h3>404 Not Found</h3>
            <div className="entity-content">
              <p className="nf-text">
                Oops! Sorry, we couldn&apos;t find what you were looking for. Did you arrive here by
                mistake? <br /> You can click on the button below to go back to home.
              </p>
            </div>
            <section className="actions">
              <Link push="true" to={ROUTES.DASHBOARD}>
                <Button variant="contained" color="primary">
                  Back to home
                </Button>
              </Link>
            </section>
          </div>
        </div>
      </div>
    </section>
  );
};

export default NotFound;
